import { render, staticRenderFns } from "./SettleRules.vue?vue&type=template&id=33361b64&scoped=true&"
import script from "./SettleRules.vue?vue&type=script&lang=js&"
export * from "./SettleRules.vue?vue&type=script&lang=js&"
import style0 from "./SettleRules.vue?vue&type=style&index=0&id=33361b64&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33361b64",
  null
  
)

export default component.exports